import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { Helpers } from '../../../helpers';
import { Router } from '@angular/router';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../../_services/common.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-expense-transaction',
  templateUrl: './expense-transaction.component.html',
  styleUrls: ['./expense-transaction.component.scss']
})
export class ExpenseTransactionComponent implements OnInit {

  static that: ExpenseTransactionComponent;
  tableDetails: ITableModel;
  totalCount: number = 0;
  noOfPages: number = 15;
  searchValue: string = '';
  filterObj: any = {
    Status: 'All'
  };
  payload: any = {};
  @Input() Id: any;
  @Input() referenceType: any;
  @Input() headerName: any;

  @Input() shipmentModetypearray: any = [];
  @Input() parentTypearray: any = [];

  data: any = {};
  reportHeader: any = [];
  TenantId: any;
  CompanyId: any;
  userId: any;

  FromDate: any = {
    formControlName: 'FromDate',
    dataField: 'FromDate',
    placeholder: 'Select FromDate'
  };
  ToDate: any = {
    formControlName: 'ToDate',
    dataField: 'ToDate',
    placeholder: 'Select ToDate'
  };
  searchFieldDetails: any = {
    placeholder: "Search",
    type: "text",
    isSearchBox: true,
  };
  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
    private datePipe: DatePipe,
  ) {
    ExpenseTransactionComponent.that = this;
  }

  ngOnInit() {
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId"))));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const storedPerPage = localStorage.getItem('perPage');
    if (storedPerPage) {
      this.noOfPages = parseInt(storedPerPage, 10);
    }
    const currentDate = new Date();
    const firstDateOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);


    this.data[this.ToDate.dataField] = this.datePipe.transform(new Date(), 'dd-MMM-yyyy');
    this.data[this.FromDate.dataField] = this.datePipe.transform(firstDateOfMonth, 'dd-MMM-yyyy');

    this.initalizeForm();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['Id']) {
      this.Id = changes['Id'].currentValue;
      if (changes['shipmentModetypearray']) {
        this.shipmentModetypearray = changes['shipmentModetypearray'].currentValue;
      }
      if (changes['parentTypearray']) {
        this.parentTypearray = changes['parentTypearray'].currentValue;
      }

    }


  }

  async initalizeForm() {
    this.tableDetails = {
      emptyDataMSg: 'No Data Found',
      data: [],
      columnDetails: [
        { columnName: 'Expense No', dataFieldName: 'ExpenseNumber' },
        { columnName: 'Date', dataFieldName: 'PostedDateString' },
        { columnName: 'Status', dataFieldName: 'StatusName', divType: 'status' },
        { columnName: 'Expense Account', dataFieldName: 'ExpenseAccountName' },
        { columnName: 'Paid Through', dataFieldName: 'PaidAccountName' },
        { columnName: 'Bill No', dataFieldName: 'BillNo', divType: '' },
        { columnName: 'Vehicle No', dataFieldName: 'VehicleName' },
        { columnName: 'Tyre', dataFieldName: 'TyreName', divType: '' },
        { columnName: 'Amount', dataFieldName: 'TotalExpenseAmount', divType: '' },
      ],
      isColumnNameShow: true
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'FromDate') {
      if (value != null) {
        this.data[this.FromDate.dataField] = value;
      }
    }
    if (data.dataField == 'ToDate') {
      if (value != null) {
        this.data[this.ToDate.dataField] = value;
      }
    }
  }

  GetTransactionList(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id,
    CompanyId
  ) {

    Helpers.setLoading(true);
    localStorage.setItem('perPage', perPage);

    if (CompanyId !== undefined && CompanyId !== null) {
      this.CompanyId = CompanyId;
    }

    this.payload.Start = pageNo * perPage;
    this.payload.Length = perPage;

    this.payload.CompanyId = (CompanyId !== undefined && CompanyId !== null) ? CompanyId : this.CompanyId;

    this.payload.SearchValue = searchValue || null;
    this.payload.BillId = null;
    this.payload.AccountId = null;

    if (this.referenceType == 'Vehicles') {
      this.payload.VehicleNo = Id ? Id : this.Id;
    }
    else {
      this.payload.VehicleNo = null;
    }

    this.payload.VehicleNo = null;
    this.payload.PaidThrough = null;
    this.payload.Financialyear = null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = null;

    if (this.referenceType == 'Driver') {
      this.payload.DriverId = Id ? Id : this.Id;
    }
    else {
      this.payload.DriverId = null;
    }

    if (this.referenceType == 'Vehicles') {
      this.payload.VehicleId = Id ? Id : this.Id;
    }
    else {
      this.payload.VehicleId = null;
    }

    this.payload.tabId = Id ? Id : this.Id;
    this.payload.tabreferenceType = this.referenceType;

    this._appService.Post("Expense", "GetCashExpense", this.payload).subscribe((response) => {
      if (response.length) {
        this.totalCount = response[0].Count;
        // this.isListApiCalled = true;
      }
      this.assignTableFields(pageNo, perPage, response);
      Helpers.setLoading(false);
    },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error while fetching data", err);
      }
    );
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data,
    }
  }

  onPageChange(pageNo: number) {
    this.GetTransactionList('', pageNo - 1, {}, this.noOfPages, this.Id, this.CompanyId);
  }

  onPageNumberChange(noOfPages: any) {
    this.noOfPages = noOfPages;
    this.GetTransactionList("", 0, {}, noOfPages, this.Id, this.CompanyId);
  }


  GetTransactionListDownload(
    searchValue = this.searchValue,
    pageNo: number = 0,
    filterObject: any = this.filterObj,
    perPage: any = this.noOfPages,
    Id
  ) {
    Helpers.setLoading(true);
    // localStorage.setItem('perPage', perPage);
    this.payload.Start = pageNo * perPage;
    this.payload.Length = this.totalCount;
    this.payload.CompanyId = this.CompanyId;
    this.payload.SearchValue = searchValue || null;
    this.payload.BillId = null;
    this.payload.AccountId = null;

    if (this.referenceType == 'Vehicles') {
      this.payload.VehicleNo = Id ? Id : this.Id;
    }
    else {
      this.payload.VehicleNo = null;
    }

    this.payload.VehicleNo = null;
    this.payload.PaidThrough = null;
    this.payload.Financialyear = null;
    this.payload.FromDate = this.data.FromDate || null;
    this.payload.ToDate = this.data.ToDate || null;
    this.payload.Status = null;

    if (this.referenceType == 'Driver') {
      this.payload.DriverId = Id ? Id : this.Id;
    }
    else {
      this.payload.DriverId = null;
    }

    this.payload.tabid = Id ? Id : this.Id;
    this.payload.referenceType = this.referenceType;


    console.log('download has not been developed')

    // this._appService.Post("VehicleMaster", "GetExpenseTransactions_Download", this.payload).subscribe((response) => {
    //   this.DownloadFile(response);
    //   Helpers.setLoading(false);
    // },
    //   (error) => {
    //     Helpers.setLoading(false);
    //     this.toastr.error("Error while downloading", error);
    //   }
    // );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
